module.exports = Object.freeze({
  ANALYTICS_TAG_FILTER_SELECT_TAGS: "Analytics:TagFilter:onSelectedGroupsChange",
  ANALYTICS_TAG_FILTER_CLEAR_ALL: "Analytics:TagFilter:onClearAllChange"
});
